module.exports = __webpack_public_path__ + "static/slide1-4ce3724099a30b2ee8a95c4998c25a55.jpg";